import { FC, ReactNode } from "react";

import "./DrawerFooter.scss";

export type DrawerFooterProps = {
  /**
   * The content of the drawer footer.
   */
  children: ReactNode;
};

const DrawerFooter: FC<DrawerFooterProps> = function ({ children }) {
  return (
    <div className="drawer-footer">
      <div className="footer-content">{children}</div>
    </div>
  );
};

export default DrawerFooter;
